/* Import libs */
import '../assets/lib/skip-link-focus-fix'

/* Main scripts */
import '../assets/js/lucci'
import '../assets/js/navigation'

import palauteSlider from '../assets/js/palaute-slider'

const appStart = () => {
    palauteSlider.init()
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', appStart)
  } else {
    appStart()
  }